import { render, staticRenderFns } from "./UserNotificationsDialogTabTips.vue?vue&type=template&id=7af2fd6c&scoped=true&"
import script from "./UserNotificationsDialogTabTips.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsDialogTabTips.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationsDialogTabTips.vue?vue&type=style&index=0&id=7af2fd6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2fd6c",
  null
  
)

export default component.exports